module.exports = __webpack_public_path__ + "img/heater1.0dcc43e9.webp";